jQuery(function ($) {

    async function hashUserData(value, type = 'email') {
        if (value == null) return null;

        const str = String(value);
        if (!str.trim()) return null;

        let normalized;

        if (type === 'email') {
            normalized = str
                .trim()
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '');
        }

        if (type === 'phone') {
            normalized = str
                .trim()
                .replace(/\s+/g, '')
                .replace(/[^+\d]/g, '');
        }

        if (!normalized) return null;

        const encoder = new TextEncoder();
        const data = encoder.encode(normalized);
        const hashBuffer = await crypto.subtle.digest('SHA-256', data);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');

        return hashHex;
    }

    function getDatalayerEventName($form) {
        if ($form.attr('data-form') === 'download') {
            return 'pdf_download';
        }

        if ($form.attr('data-product') === '1') {
            return 'product_inquiry';
        }

        return 'contact_form_submit';
    }

    async function pushDatalayerForForm($form) {
        if (!window.dataLayer) return;

        const eventName = getDatalayerEventName($form);

        const email = $form.find('[name="email"]').val();
        const phone = $form.find('[name="phone"]').val();

        window.dataLayer.push({
            event: eventName,
            user_data: {
                email: await hashUserData(email, 'email'),
                phone_number: await hashUserData(phone, 'phone'),
            }
        });
    }

    function contactFormInit() {
        const contactForms = $(".contactform form.contact-form");

        if (!contactForms.length) return;

        $.validator.methods.email = function (value, element) {
            return this.optional(element) ||
                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
        };

        contactForms.each(function () {
            const $form = $(this);

            if ($form.data("validator-initialized")) return;
            $form.data("validator-initialized", true);

            $form.validate({
                submitHandler: function (formEl) {
                    const $thisForm = $(formEl);

                    const gdprCheckbox = $thisForm.find("[name=gdpr]");
                    const gdprError = $thisForm.find(".checkbox-error[data-type=gdpr]");
                    gdprError.hide();

                    if (gdprCheckbox.length && !gdprCheckbox.is(":checked")) {
                        gdprError.fadeIn(200);
                        return false;
                    }

                    const data = $thisForm.serialize();

                    $thisForm
                        .find('[type="submit"]')
                        .addClass("active")
                        .prop("disabled", "disabled");

                    $.ajax({
                        type: "post",
                        url: jsvar.ajax_url,
                        data: data + "&action=contactForm",
                        success: function (response) {
                            if (response.data?.redirect) {
                                pushDatalayerForForm($thisForm);
                                window.location.href = response.data.redirect;
                                return;
                            }

                            const wrapper = $thisForm.closest(".contactform");

                            wrapper.find(".contactform__title").remove();
                            wrapper.find(".contactform__textbox").remove();

                            $thisForm.replaceWith(response.data.html);

                            pushDatalayerForForm($thisForm);
                        }
                    });
                }
            });
        });
    }

    contactFormInit();
    const observer = new MutationObserver(() => contactFormInit());
    observer.observe(document.body, { childList: true, subtree: true });

    function switchContactFormContent(type) {
        if (!window.jsvar || !jsvar.contact_forms) return;

        const config = jsvar.contact_forms;
        const data = config[type] || config.machine;

        const $modal = $('.modal[data-id="demand"]');
        if (!$modal.length) return;

        $modal.find('[data-cf-title]').html(data.title || '');
        $modal.find('[data-cf-description]').html(data.desc || '');

        if (data.message) {
            $modal.find('[data-cf-message]').attr('placeholder', data.message || '');
        }
    }

    function showFormVariant($modal, variant) {
        const $normal = $modal.find('form.contact-form[data-form="normal"]');
        const $download = $modal.find('form.contact-form[data-form="download"]');

        if (variant === "download") {
            $normal.hide();
            $download.show();
        } else {
            $download.hide();
            $normal.show();
        }
    }

    function showHeaderVariant($modal, variant) {
        const $normalHeader = $modal.find('[data-header="normal"]');
        const $downloadHeader = $modal.find('[data-header="download"]');

        if (variant === "download") {
            $normalHeader.hide();
            $downloadHeader.show();
        } else {
            $downloadHeader.hide();
            $normalHeader.show();
        }
    }

    function resetDemandModal($modal) {
        showHeaderVariant($modal, "normal");
        showFormVariant($modal, "normal");

        $modal.find('form.contact-form[data-form="download"] input[name="attachment_id"]').val("");
    }

    $(document).on("click", "[data-modal]", function (e) {
        e.preventDefault();

        const $trigger = $(this);

        const id = $trigger.data("modal");

        const formType = $trigger.data("form-type") || null;
        const formMode = $trigger.data("form-mode") || null;
        const isDownload = (formType === "download" || formMode === "download");

        const attachmentId = $trigger.data("attachment-id") || null;

        const type = (!isDownload && formType) ? formType : "general";

        const $modal = $(`.modal[data-id="${id}"]`);
        const $template = $modal.find("template");

        if ($template.length) {
            const content = $template[0].content.cloneNode(true);
            $modal.append(content);
            $template.remove();
        }

        resetDemandModal($modal);

        if (isDownload) {
            showHeaderVariant($modal, "download");
            showFormVariant($modal, "download");

            if (attachmentId) {
                $modal
                    .find('form.contact-form[data-form="download"] input[name="attachment_id"]')
                    .val(attachmentId);
            }

            if (jsvar?.contact_forms?.download?.title) {
                $modal.find('[data-download-title]').text(jsvar.contact_forms.download.title);
            }
        } else {
            showHeaderVariant($modal, "normal");
            showFormVariant($modal, "normal");
            switchContactFormContent(type);
        }

        $modal.addClass("active");
    });

    $(document).on("click", "[data-modal-close]", function () {
        const $modal = $(this).closest(".modal");
        resetDemandModal($modal);
        $modal.removeClass("active");
    });

    $(document).on("mousedown", ".modal", function (e) {
        const $target = $(e.target);
        if (!$target.closest(".modal-wrap").length) {
            const $modal = $(this);
            resetDemandModal($modal);
            $modal.removeClass("active");
        }
    });

});
